import { Box, Grid } from "@mui/material";
import TruckForSalePopup from "../../components/Sales/TruckForSalePopup/TruckForSalePopup";
import TruckSalesTable from "../../components/Sales/TruckSalesTable/TruckSalesTable";
import GenerateBillOfSaleButton from "../../components/Sales/GenerateBillOfSaleButton/GenerateBillOfSaleButton";

const TruckSalesPage = () => {
  return (
    <Box className="driver-page">
      <Grid container spacing={1} alignItems="center" justifyContent="center">
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box
            sx={{
              flexWrap: { xs: "wrap", lg: "nowrap" },
              flex: 1,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="center"
              sx={{ maxWidth: "800px" }}
            >
              <Grid item>
                <TruckForSalePopup />
                <GenerateBillOfSaleButton />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <TruckSalesTable />
        </Grid>
      </Grid>
    </Box>
  );
};

export default TruckSalesPage;
